export const SHOW_SECURITY = 'SHOW_SECURITY';
export const LOADING_SECURITY = 'LOADING_SECURITY';